/**
 * Minutes since midnight for a lead-page time slot value.
 *
 * Slot values come from generate_time_slots_by_date() (functions.php):
 *   FR / BE -> "H\hi"  e.g. "09h30", "14h00"
 *   GB      -> "h:iA"  e.g. "09:30AM", "12:00PM", "01:30PM"
 *
 * @param {string} value       Slot value.
 * @param {string} countryCode COUNTRY_CODE ('fr', 'be', 'gb').
 * @return {number} Minutes since midnight, NaN when the value can't be parsed.
 */
export function slotValueToMinutes(value, countryCode) {
    const timeString = String(value || '').trim();
    let hour;
    let minute;

    if ('gb' === countryCode) {
        hour = parseInt(timeString.slice(0, 2), 10);
        minute = parseInt(timeString.slice(3, 5), 10);

        const meridiem = timeString.slice(-2).toUpperCase();

        if ('PM' === meridiem && hour < 12) {
            hour += 12;
        } else if ('AM' === meridiem && 12 === hour) {
            hour = 0;
        } else if ('PM' !== meridiem && 'AM' !== meridiem && hour < 9) {
            // Legacy fallback: slots run 09:30-18:00, so a bare 01-08 is afternoon.
            hour += 12;
        }
    } else {
        hour = parseInt(timeString.split('h')[0], 10);
        minute = parseInt(timeString.split('h')[1], 10);
    }

    return hour * 60 + minute;
}
